export default {
  apiKey: import.meta.env.VUE_APP_API_KEY,
  authDomain: "vrchitecht.firebaseapp.com",
  databaseURL: "https://vrchitecht.firebaseio.com",
  projectId: "vrchitecht",
  storageBucket: "vrchitecht.appspot.com",
  messagingSenderId: import.meta.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: import.meta.env.VUE_APP_APP_ID,
  measurementId: import.meta.env.VUE_APP_MEASUREMENT_ID,
};
